module.exports = __webpack_public_path__ + "c47a346a5e6f96a6e4b773d59cb33a5f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tiger_old2.jpg
// module id = 47
// module chunks = 2